<script setup lang="ts">
    import { useSlots } from 'vue';

    const slots = useSlots();
</script>

<template>
    <div class="bg-white shadow-md rounded-md">
        <div class="flex justify-between p-6 gap-2 items-center flex-row lg:gap-0.5">
            <h1 class="heading-xl-light flex">
                <div class="flex items-center pl-3">
                    <span
                        v-if="slots.icon"
                        aria-hidden="true"
                        class="block flex-shrink-0 w-10 h-10 mr-3 -ml-3 text-gray-dark"
                    >
                        <slot name="icon" />
                    </span>
                    <slot />
                </div>
            </h1>

            <div v-if="slots.links" class="flex gap-3 py- md:py-0">
                <slot name="links" />
            </div>
        </div>
    </div>
</template>
